const noop = () => {}

export default function ViewerHuman(canvas, { onGrab = noop, onHover = noop, onDrag = noop, onDrop = noop } = {}) {
    let isDown = false

    const pointerDown = ({ pageX: x0, pageY: y0 }) => {
        if (isDown) {
            return
        }

        onGrab({
            x: x0,
            y: y0,
        })

        isDown = true

        const onPointerMove = ({ pageX: x, pageY: y }) => {
            onDrag({
                x,
                y,
            })
        }

        const onPointerUp = () => {
            window.removeEventListener('pointermove', onPointerMove)
            window.removeEventListener('pointerup', onPointerUp, false)

            if (!isDown) {
                return
            }

            onDrop()

            isDown = false
        }

        window.addEventListener('pointermove', onPointerMove)
        window.addEventListener('pointerup', onPointerUp, false)
    }

    const pointerMove = ({ pageX: x, pageY: y }) => {
        if (!isDown) {
            onHover({
                x,
                y,
            })
        }
    }

    canvas.addEventListener('pointerdown', pointerDown, false)
    canvas.addEventListener('pointermove', pointerMove)
    canvas.addEventListener('touchmove', (e) => {
        e.preventDefault()
        e.stopPropagation()
    }, false)
}
